/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { ApiFiscal } from '../../axiosfiscal';
import { v4 as uuidv4 } from 'uuid';

export interface IListagemNfe {
  idnfe: string;
  dataemissao: Date;
  nfe: number;
  produtor: string;
  parceiros: string;
  cpf: string;
  vnfe: number;
  status: number;
}

export interface IitensNfe {
  iditens: string;
  idprod: string;
  cfop: number;
  cst: number;
  quantidade: number;
  preco: number;
  desconto: number;
  total: number;
  frete: number;
  seguro: number;
  bcicms: number;
  percentual: number;
  valoricms: number;
  bcst: number;
  percentualst: number;
  valoricmsst: number;
  cstipi: number;
  bcipi: number;
  percentualipi: number;
  valoripi: number;
  cstpis: number;
  bcpis: number;
  percentualpis: number;
  valorpis: number;
  cstcofins: number;
  bccofins: number;
  percentualcofins: number;
  valorcofins: number;
  voutros: number;
  preducaoicms: number;
  modbc: string,
  modbcst: string,
  indtot: boolean,
}

interface IItensNFe {
  iditens: string;
  idprod: string;
  descricao: string;
  un: string;
  ncm: string;
  cfop: number;
  cst: string;
  quantidade: number;
  preco: number;
  desconto: number;
  total: number;
  frete: number;
  seguro: number;
  bcicms: number;
  percentual: number;
  valoricms: number;
  bcst: number;
  percentualst: number;
  valoricmsst: number;
  cstipi: string;
  bcipi: number;
  percentualipi: number;
  valoripi: number;
  cstpis: string;
  bcpis: number;
  percentualpis: number;
  valorpis: number;
  cstcofins: string;
  bccofins: number;
  percentualcofins: number;
  valorcofins: number;
  voutros: number;
  preducaoicms: number;
  modbc: string,
  modbcst: string,
  indtot: boolean,
}

interface IItensNFe {
  iditens: string;
  idprod: string;
  descricao: string;
  un: string;
  ncm: string;
  cfop: number;
  cst: string;
  quantidade: number;
  preco: number;
  desconto: number;
  total: number;
  frete: number;
  seguro: number;
  bcicms: number;
  percentual: number;
  valoricms: number;
  bcst: number;
  percentualst: number;
  valoricmsst: number;
  cstipi: string;
  bcipi: number;
  percentualipi: number;
  valoripi: number;
  cstpis: string;
  bcpis: number;
  percentualpis: number;
  valorpis: number;
  cstcofins: string;
  bccofins: number;
  percentualcofins: number;
  valorcofins: number;
  voutros: number;
  bcicmsst: number;
  preducaoicms: number;
  modbc: string,
  modbcst: string,
}

interface Igetnfe {
  serie: number;
  nfe: number;
  dataemissao: Date;
  finnfe: number;
  nfecpl: string;
  tpag: string;
  cfop: number;
  obscomplementar: string;
  idprodutor: number;
  idparceiro: string;
  idtransportadora?: string | null;
  volumequantidade: number;
  volumemarca: string;
  volumepesoliquido: number;
  volumepesobruto: number;
  vprod: number;
  vbc: number;
  vicms: number;
  vfrete: number;
  vseg: number;
  vdesc: number;
  vipi: number;
  vpis: number;
  vconfins: number;
  vnfe: number;
  idfazenda: string;
  nferef: string;
  tpnfe: number;
  volesp: string;
  idveiculo?: string | null;
  modfrete: number;
  status: number;
  pathpdf: string;
  protocolo: string;
  dataenvio: Date;
  tpemis: number;
  itens: IItensNFe[];
}


interface IDetalhenfe {
  serie: number;
  nfe: number;
  dataemissao: Date;
  finnfe: number;
  nfecpl: string;
  tpag: string;
  cfop: number;
  obscomplementar: string;
  idprodutor: number;
  idparceiro: string;
  idtransportadora?: string | null;
  volumequantidade: string;
  volumemarca: string;
  volumepesoliquido: number;
  volumepesobruto: number;
  vprod: number;
  vbc: number;
  vicms: number;
  vfrete: number;
  vseg: number;
  vdesc: number;
  vipi: number;
  vpis: number;
  vconfins: number;
  vnfe: number;
  idfazenda: string;
  nferef: string;
  tpnfe: number;
  volesp: string;
  idveiculo?: string | null;
  modfrete: number;
  tpemis: number;
}

interface IItensids {
  iditens: string;
}

export interface IRNFE {
  serie: number;
  nfe: number;
  dataemissao: Date;
  nome: string;
  fazenda: string;
  cpf: string;
  cfop: number;
  vnfe: number;
  finalidade: string;
  status: string;
}

interface INfecancelar {
  justificativa: string;
  nseqevento: number;
}

interface INfeCartaCorrecao {
  xtexto: string;
  nseqevento: number;
}

type TotalCount = {
  data: IListagemNfe[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const getAll = async (page = 1, filter = '', tipo = ''): Promise<TotalCount | Error> => {
  try {

    const urlRelativa = `/nfe?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}&tipo=${tipo}`;

    const { data, headers } = await ApiFiscal.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<Igetnfe | Error> => {
  try {

    const { data } = await ApiFiscal.get(`/nfe/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IDetalhenfe, dadositens: IItensNFe[]): Promise<string | Error> => {
  try {
    const guuid = uuidv4();

    const dadosExtraidos = dadositens.map(({ descricao, ncm, ...restoDoObjeto }) => ({ idnfe: guuid, ...restoDoObjeto }));

    const dadosnfe = { idnfe: guuid, ...dados };

    const { data } = await ApiFiscal.post<IDetalhenfe>('/nfe', [dadosnfe, dadosExtraidos]);

    if (Object.keys(data).length === 0) {
      return guuid;
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IDetalhenfe, dadositens: IItensNFe[], iddeletados: IItensids[]): Promise<void | Error> => {
  try {

    const dadosExtraidos = dadositens.map(({ descricao, ncm, ...restoDoObjeto }) => ({ idnfe: id, ...restoDoObjeto }));

    await ApiFiscal.put(`/nfe/${id}`, [dados, dadosExtraidos, iddeletados]);

  } catch (error) {

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

interface ErrorResponse {
  error: {
    default: string;
  };
}

const transmitir = async (id: string): Promise<Blob | Error> => {
  try {
    const { data } = await ApiFiscal.get(`/geranfe/${id}`, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const blob = error.response.data as Blob;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        const errorMessage = json?.error?.default || 'Erro desconhecido na resposta';
        return new Error(errorMessage);
      } catch (parseError) {
        const fallbackText = await blob.text();
        return new Error(fallbackText || 'Erro desconhecido ao processar a resposta');
      }
    } else if (axios.isAxiosError(error) && error.request) {
      return new Error('Nenhuma resposta do servidor');
    } else if (axios.isAxiosError(error)) {
      return new Error(error.message);
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Imprimir = async (id: string): Promise<Blob | Error> => {
  try {
    const { data } = await ApiFiscal.get(`/geradanf/${id}`, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const addprotocolo = async (id: string): Promise<string | Error> => {
  try {
    const { data } = await ApiFiscal.put(`/addprotocolo/${id}`);
    return data.pdf;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const cancelarnfe = async (id: string, dados: INfecancelar): Promise<Blob | Error> => {
  try {
    const { data } = await ApiFiscal.put(`/cancelarnfe/${id}`, dados, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const blob = error.response.data as Blob;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        const errorMessage = json?.error?.default || 'Erro desconhecido na resposta';
        return new Error(errorMessage);
      } catch (parseError) {
        const fallbackText = await blob.text();
        return new Error(fallbackText || 'Erro desconhecido ao processar a resposta');
      }
    } else if (axios.isAxiosError(error) && error.request) {
      return new Error('Nenhuma resposta do servidor');
    } else if (axios.isAxiosError(error)) {
      return new Error(error.message);
    } else {
      return new Error('Erro inesperado');
    }
  }
};

// const cartacorrecao = async (id: string, dados: INfeCartaCorrecao): Promise<string | Error> => {
//   try {
//     const { data } = await ApiFiscal.put(`/cartacorrecao/${id}`, dados);
//     return data.pdf; 
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       const axiosError = error as AxiosError<ErrorResponse>;
//       if (axiosError.response) {
//         const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
//         return new Error(errorMessage);
//       } else if (axiosError.request) {
//         return new Error('Nenhuma resposta do servidor');
//       } else {
//         return new Error(axiosError.message);
//       }
//     } else {
//       return new Error('Erro inesperado');
//     }
//   }
// };

const cartacorrecao = async (id: string, dados: INfeCartaCorrecao): Promise<Blob | Error> => {
  try {
    const { data } = await ApiFiscal.put(`/cartacorrecao/${id}`, dados, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const blob = error.response.data as Blob;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        const errorMessage = json?.error?.default || 'Erro desconhecido na resposta';
        return new Error(errorMessage);
      } catch (parseError) {
        const fallbackText = await blob.text();
        return new Error(fallbackText || 'Erro desconhecido ao processar a resposta');
      }
    } else if (axios.isAxiosError(error) && error.request) {
      return new Error('Nenhuma resposta do servidor');
    } else if (axios.isAxiosError(error)) {
      return new Error(error.message);
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Relatorio = async (produtor = 0, tipo = '', dataInicial = '', dataFinal = ''): Promise<IRNFE[] | Error> => {
  try {
    const urlRelativa = `/relatorionfe?produtor=${produtor}&tipo=${tipo}&datainicial=${dataInicial}&datafinal=${dataFinal}`;

    const { data } = await ApiFiscal.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const baixaxml = async (id: string, numero: string): Promise<void | Error> => {
  try {
    const response = await ApiFiscal.get(`/xmlnfe/${id}`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = numero+'.xml';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const NfeService = {
  getAll,
  create,
  getById,
  updateById,
  transmitir,
  cancelarnfe,
  Relatorio,
  addprotocolo,
  cartacorrecao,
  Imprimir,
  baixaxml,
};